export default __webpack_public_path__ + "static/Step-9-a7d2108a074a692841e2f2fc8df467fa.svg";